import React, { ReactElement } from 'react';

import { Calendar as CalendarBase, CalendarPropsType } from 'src/domains/common/components/calendar/calendar';

export const Calendar = (props: CalendarPropsType): ReactElement | null => {
    return (
        <CalendarBase
            isCampaignCreation={true}
            {...props}
        />
    );
};
